<template>
  <div prop="variable" class="sky-server-config wsp-line-height-28">
    <div class="wsp-padding-bottom-2 wsp-border-bottom-2 wsp-width-8">
      <strong>升级场景</strong>
    </div>
    <div class="wsp-display-flex wsp-padding-left-12">
      <div class="wsp-width-49 wsp-display-flex">
        <div class="wsp-display-flex-center"><label>场景名称：</label></div>
        <div class="wsp-display-flex-center">{{ variable.sourceSceneName }}</div>
      </div>
      <div class="wsp-display-flex-center"></div>
      <div class="wsp-width-49 wsp-display-flex">
        <div class="wsp-display-flex-center"></div>
        <div class="wsp-display-flex-center wsp-width-65"></div>
      </div>
    </div>
    <div class="wsp-padding-bottom-2 wsp-border-bottom-2 wsp-width-8">
      <strong>产品版本</strong>
    </div>
    <div class="wsp-display-flex wsp-padding-left-12" v-for="(item, index) in variable.productUpgradeList" :key="index">
      <div class="wsp-width-49 wsp-display-flex">
        <div class="wsp-display-flex-center"><label>源产品版本：</label></div>
        <div class="wsp-display-flex-center wsp-width-50">
          {{ item.sourceProductName }}
        </div>
      </div>
      <div class="wsp-display-flex-center">
        <i class="el-icon-arrow-right" />
      </div>
      <div class="wsp-width-49 wsp-display-flex">
        <div class="wsp-display-flex-center"><label>目标产品版本：</label></div>
        <div class="wsp-display-flex-center wsp-width-65">
          <el-select
            placeholder="请选择目标产品版本"
            clearable
            v-model="item.targetProductId"
            filterable
            style="width: 100% !important;"
            @change="productChange"
          >
            <el-option v-for="(item, index) in productList" :key="index" :label="item.label" :value="item.id">
            </el-option>
          </el-select>
        </div>
      </div>
    </div>
    <div style="color: red;">{{ message }}</div>
    <div style="text-align: center;">
      <el-button type="primary" class="sky-branch-pattern__add" style="margin-top:5px" @click="onConfirm">
        确定
      </el-button>
      <el-button class="sky-branch-pattern__add" style="margin-top:5px" @click="onCancel">
        取消
      </el-button>
    </div>
  </div>
</template>
<script type="text/babel">
import { Select, Option, Input, Button } from 'element-ui'
import { action } from 'sky-engine/api'

import { SCENE_MNG, PRODUCT_MNG } from '@/api/apiModules'

export default {
  name: 'SkyProductUpgrade',
  inject: ['rootView'],
  components: {
    [Select.name]: Select,
    [Option.name]: Option,
    [Input.name]: Input,
    [Button.name]: Button
  },
  props: {
    scene: {}
  },
  data() {
    return {
      loading: false,
      message: null,
      productList: [],
      variable: {
        sourceSceneId: null,
        sourceSceneName: null,
        productUpgradeList: []
      }
    }
  },
  created() {
    this.variable.sourceSceneId = this.scene.id
    this.variable.sourceSceneName = this.scene.sceneName
    this.variable.productUpgradeList = this.scene.recommendProductList.map(item => {
      return {
        sourceProductId: item.id,
        sourceProductName: item.productVersion,
        targetProductId: null
      }
    })
  },
  mounted() {
    action(PRODUCT_MNG, 'findAllActive').then(response => {
      this.productList = response.data.content.itemArr.map(item => {
        return {
          id: item.id,
          label: item.productVersion
        }
      })
    })
  },
  watch: {},
  methods: {
    productChange() {
      this.isFill()
    },
    isFill() {
      this.message = ''
      if (this.variable && this.variable.productUpgradeList) {
        const cnt = this.variable.productUpgradeList.filter(item => item.targetProductId != null).length
        if (cnt === 0) {
          this.message = '请选择至少一个目标产品版本'
          return false
        }
        for (const obj of this.variable.productUpgradeList) {
          if (obj.sourceProductId == obj.targetProductId) {
            this.message = '目标产品版本不能与源产品版本相同'
            return false
          }
        }
      }
      if (this.variable && this.variable.productUpgradeList?.length > 1) {
        const ids = this.variable.productUpgradeList
          .filter(item => {
            return item.targetProductId != null
          })
          .map(item => item.targetProductId)
        const hasDuplicate = new Set(ids).size !== ids.length

        if (hasDuplicate) {
          this.message = '目标产品版本不能重复'
          return false
        }
      }
      return true
    },
    onConfirm() {
      if (!this.isFill()) return
      action(SCENE_MNG, 'productUpgrade', this.variable)
        .then(response => {
          this.$emit('cb')
          this.$store.dispatch('OpenNotification', {
            message: '升级产品版本成功',
            type: 'success'
          })
        })
        .catch(e => {
          throw e
        })
    },
    onCancel() {
      this.$emit('cb')
    }
  }
}
</script>
<style lang="scss">
@import '~sky-engine/assets/styles/common/var.scss';
@import '~sky-engine/assets/styles/mixin/mixin.scss';

@include b(version-variable) {
  @include e(more-btn) {
    & .el-button {
      background-color: $--fill-base !important;
      color: $--color-primary !important;
      border: 0 !important;
      line-height: $--font-line-height-base - 0.2em;
      &:hover {
        color: $--color-primary-5 !important;
      }
    }
  }
}
@include b(server-config) {
  margin-bottom: 0px !important;
  @include e(autocomplete) {
    width: auto !important;
    min-width: 180px;
  }
  @include e(select) {
    width: 180px !important;
  }
  @include e(mutiple-select) {
    width: 300px !important;
  }
  @include e(item) {
    line-height: 30px;
    word-break: break-all;
    width: 1400px !important;
    color: $--disabled-color-base;
    &.active {
      color: $--color-primary;
    }
  }
  & i {
    margin-right: 5px;
  }
  & .el-input__inner {
    border-top: 0;
    border-left: 0;
    border-right: 0;
    padding: 0;
  }
  & .el-form-item__error {
    width: 500px !important;
  }
}
</style>
